import { TeamType } from "./types";
import { getImageByTeamType } from "./utils";

type Props = {
    teamType: TeamType;
};

const RightHandSide = ({ teamType }: Props) => {
    const Asset = getImageByTeamType(teamType);

    return <Asset />;
};

export default RightHandSide;
